import environment from './environment';

export enum Features {
  CDNImages = "CDNImages",
  FeatureOne = 'FeatureOne',
  FeatureTwo = 'FeatureTwo',
  FeatureThree = 'FeatureThree',
  ShowSearch = 'ShowSearch',
  ShowContact = 'ShowContact',
}

export function isEnabled(name: string): boolean {
  const automatedTest = environment.ENV === 'automated_test'; // @ts-expect-error Error after adding strictNullChecks:true to tsconfig
  const hasLocalStorage = JSON.parse(localStorage.getItem(name));
  const isPreActivated = environment.FEATURES?.includes(name);
  return automatedTest || (hasLocalStorage ?? isPreActivated);
}
